import { Routes, Route } from "react-router";

import CadastroUsuarios from "../pages/cadastroUsuarios";
import Home from "../pages/home";
import Premium from "../pages/payment/premium";
import PaymentCallback from "../pages/payment/callback";
import Login from "../pages/auth/login";
import Register from "../pages/auth/register";

// Desafios Picantes
import HelpDesafiosPicantes from "../pages/howToPlay/desafiosPicantes";
import CategoriasDesafios from "../pages/desafiosPicantes/categorias";
import DesafiosPreGame from "../pages/desafiosPicantes/preGame";
import DesafiosGame from "../pages/desafiosPicantes/game";
import DesafiosPlayerCategories from "../pages/desafiosPicantes/playerCategories";
import DesafiosPlayerChallenges from "../pages/desafiosPicantes/playerChallenges";

// Kamasutra
import HelpKamasutra from "../pages/howToPlay/kamasutra";
import KamasutraCards from "../pages/kamasutra/cards";
import KamasutraThemes from "../pages/kamasutra/themes";
import KamasutraGame from "../pages/kamasutra/game";

// Sex Roulette
import SexRouletteCategories from "../pages/sexRoulette/categorias";
import SexRouletteHelp from "../pages/howToPlay/sexRoulette";
import SexRouletteGame from "../pages/sexRoulette/game";

// Solo
import SoloPlayer from "../pages/solo/player";
import SoloCategories from "../pages/solo/categories";
import SoloPlayerCategories from "../pages/solo/playerCategories";
import SoloPlayerChallenges from "../pages/solo/playerChallenges";
import SoloGame from "../pages/solo/game";

// Verdade ou Desafio
import VerdadeDesafioHelp from "../pages/howToPlay/verdadeDesafio";
import VerdadeDesafioGame from "../pages/verdadeDesafio/game";
import VerdadeDesafioCategories from "../pages/verdadeDesafio/categories";

// Quiz
import QuizPlayer from "../pages/quiz/player";
import QuizGame from "../pages/quiz/game";

export default function routes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/users" element={<CadastroUsuarios />} />
      <Route path="/home" element={<Home />} />
      <Route path="/premium" element={<Premium />} />
      <Route path="/premium/callback" element={<PaymentCallback />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/hot-challenges">
        <Route path="" element={<CategoriasDesafios />} />
        <Route path="how-to-play" element={<HelpDesafiosPicantes />} />
        <Route path="pre-game" element={<DesafiosPreGame />} />
        <Route
          path="player-categories"
          element={<DesafiosPlayerCategories />}
        />
        <Route
          path="player-challenges"
          element={<DesafiosPlayerChallenges />}
        />
        <Route path="game" element={<DesafiosGame />} />
      </Route>
      <Route path="/kamasutra">
        <Route path="" element={<KamasutraCards />} />
        <Route path="how-to-play" element={<HelpKamasutra />} />
        <Route path="themes" element={<KamasutraThemes />} />
        <Route path="game" element={<KamasutraGame />} />
      </Route>
      <Route path="/sex-roulette">
        <Route path="" element={<SexRouletteCategories />} />
        <Route path="how-to-play" element={<SexRouletteHelp />} />
        <Route path="game" element={<SexRouletteGame />} />
      </Route>
      <Route path="/solo">
        <Route path="" element={<SoloPlayer />} />
        <Route path="categories" element={<SoloCategories />} />
        <Route path="player-categories" element={<SoloPlayerCategories />} />
        <Route path="player-challenges" element={<SoloPlayerChallenges />} />
        <Route path="game" element={<SoloGame />} />
      </Route>
      <Route path="/truth-or-dare">
        <Route path="" element={<VerdadeDesafioCategories />} />
        <Route path="how-to-play" element={<VerdadeDesafioHelp />} />
        <Route path="game" element={<VerdadeDesafioGame />} />
      </Route>
      <Route path="/quiz">
        <Route path="" element={<QuizPlayer />} />
        <Route path="game" element={<QuizGame />} />
      </Route>
      {/* 404 */}
      <Route element={<Home />} />
    </Routes>
  );
}
